import { useHistory } from 'react-router-dom';
import useUserContext from './useUserContext';

const useGoToHome = () => {
  const history = useHistory();
  const { user } = useUserContext();
  if (user.homePageUrl && user.homePageUrl !== '') {
    history.push(user.homePageUrl, { skipPrompt: true });
  }
};

export default useGoToHome;
